import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../../Containers/Config/index.js';
import {
  CLIENT_VERTICAL_WISE_BOOKINGS_DATA,
  CLIENT_VERTICAL_WISE_BOOKINGS_DATA_ERROR,
  CLIENT_VERTICAL_WISE_BOOKINGS_DATA_SUCCESS,
} from '../../../../../actionType.js';
import apiCall from '../../../../../apiCall.js';

function* clientVerticalWiseBookingsData({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: CLIENT_VERTICAL_WISE_BOOKINGS_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CLIENT_VERTICAL_WISE_BOOKINGS_DATA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CLIENT_VERTICAL_WISE_BOOKINGS_DATA_ERROR, payload: error });
  }
}

export function* watchClientVerticalWiseBookingsData() {
  yield takeEvery(CLIENT_VERTICAL_WISE_BOOKINGS_DATA, clientVerticalWiseBookingsData);
}

function* clientVerticalWiseBookingsDataSaga() {
  yield all([fork(watchClientVerticalWiseBookingsData)]);
}

export default clientVerticalWiseBookingsDataSaga;
